import React, { SVGProps } from 'react';
import { SvgIcon, SvgIconProps, useTheme } from '@quillbot/design-system';
import {
  premiumFeatherWFInline,
  premiumFeatherWFWhiteBoundary,
  premiumFeatherWFBoldBoundary,
  darkPremiumFeatherWFInline,
  // eslint-disable-next-line import/no-unresolved
} from 'public/images/svgPath.json';

interface IProps extends SvgIconProps {
  transparent?: boolean;
}

const PremiumIcon = (props: IProps) => {
  const { transparent, ...otherProps } = props;
  const theme = useTheme();

  return (
    <SvgIcon {...otherProps} viewBox="0 0 16 15">
      {transparent ? (
        <path
          {...(premiumFeatherWFWhiteBoundary as SVGProps<SVGPathElement>)}
        />
      ) : (
        <>
          {theme.palette.mode === 'light' ? (
            <path {...(premiumFeatherWFInline as SVGProps<SVGPathElement>)} />
          ) : (
            <path
              {...(darkPremiumFeatherWFInline as SVGProps<SVGPathElement>)}
            />
          )}
          <path
            {...(premiumFeatherWFBoldBoundary as SVGProps<SVGPathElement>)}
          />
        </>
      )}
    </SvgIcon>
  );
};

export default PremiumIcon;
